import React, { memo } from 'react';
import Avatar from 'react-avatar';
import PropTypes from 'prop-types';

const ChatAvatar = ({ size, round, urlPhoto, name, color }) => {
  return (
    <Avatar
      size={size}
      round={round}
      src={urlPhoto}
      name={name}
      color={color}
    />
  );
};

ChatAvatar.propTypes = {
  size: PropTypes.string.isRequired,
  round: PropTypes.string,
  urlPhoto: PropTypes.string,
  name: PropTypes.string.isRequired,
  color: PropTypes.string,
};

ChatAvatar.defaultProps = {
  urlPhoto: '',
  round: '',
  color: '',
};

export default memo(ChatAvatar);
